import { useEffect, RefObject, useCallback } from 'react';

/**
 * client-event-listeners: Deduplicated click-outside handler
 * Closes dropdown/modal when clicking outside the referenced element
 */
export const useClickOutside = (
  ref: RefObject<HTMLElement>,
  handler: () => void,
  enabled: boolean = true
): void => {
  // rerender-functional-setstate: Stable callback reference
  const stableHandler = useCallback(handler, [handler]);

  useEffect(() => {
    if (!enabled) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        stableHandler();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [ref, stableHandler, enabled]);
};
